export const THEMES = [
  { id: 1, name: 'global.family-friendly', slug: 'family' },
  { id: 2, name: 'filter.spa-hotel', slug: 'spa' },
  { id: 3, name: 'filter.business-hotel', slug: 'business' },
  { id: 4, name: 'filter.pets-allowed', slug: 'pet-friendly' },
  { id: 5, name: 'filter.romantic-hotel', slug: 'romantic' },
]
